"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CredentialExpirationCalculator = void 0;
const luxon_1 = require("luxon");
const _1 = require(".");
class CredentialExpirationCalculator {
    /**
     * Calculates an expiration date given an expiration policy and credential
     * - Finds the first rule that matches a credential condition
     * - Calculates the expiration date from the rule and policy timezone
     */
    static credentialExpiration(policy, status, completedDate, ruleSystem, ruleType, ruleValue) {
        const matchedRule = policy.findEffectiveRuleByCondition({
            type: 'credential',
            rule_system: ruleSystem,
            rule_type: ruleType,
            rule_value: ruleValue,
        }, completedDate);
        if (matchedRule) {
            if (status !== 'complete' || !completedDate) {
                return null;
            }
            switch (matchedRule.term) {
                case 'seasons':
                    return _1.ExpirationCalculator.seasonalExpiration(completedDate, policy.timezone, matchedRule);
                default:
                    return _1.ExpirationCalculator.rollingExpiration(completedDate, policy.timezone, matchedRule);
            }
        }
        return undefined;
    }
    static credentialRenewal(policy, completedDate, expirationDate, ruleSystem, ruleType) {
        const matchedRule = policy.findEffectiveRuleByCondition({
            type: 'credential',
            rule_system: ruleSystem,
            rule_type: ruleType,
        }, completedDate);
        if (matchedRule) {
            let renewalYearOffset = 0;
            switch (matchedRule.term) {
                case 'seasons':
                    if (matchedRule.season.renewal_month > matchedRule.season.expiration_month) {
                        renewalYearOffset = 1;
                    }
                    return luxon_1.DateTime.fromObject({
                        year: expirationDate.getFullYear() - renewalYearOffset,
                        month: matchedRule.season.renewal_month,
                        day: matchedRule.season.renewal_day,
                        zone: policy.timezone,
                    })
                        .startOf('day')
                        .toUTC()
                        .toJSDate();
                default:
                    return luxon_1.DateTime.fromJSDate(expirationDate)
                        .setZone(policy.timezone)
                        .minus({ days: 60 })
                        .startOf('day')
                        .toUTC()
                        .toJSDate();
            }
        }
        return undefined;
    }
}
exports.CredentialExpirationCalculator = CredentialExpirationCalculator;
